<template v-if="list.length" lang="html">
  <table class="admin-table vacancies-table">
    <thead>
      <tr>
        <th class="column-id"></th>

        <th class="column-owner">
          <div>
            {{ $tr('admin_console.company.response_refill.count') }}
          </div>
        </th>

        <th class="column-date">
          <span>{{ $tr('common.list.created') }}</span>
        </th>

      </tr>
    </thead>
    <tbody>
      <refill-row
        v-for="(item, index) in list"
        :model="item"
        :companyId="companyId"
        :key="item.id"
        :is_japan_locale="is_japan_locale"
      />
    </tbody>
  </table>
</template>

<script>
  import { STORE_PREFIX } from '../constants.js';
  import { mapGetters } from 'vuex';

  import RefillRow from './Row.vue'

  export default {
    name: 'refill-list',

    components: {
      RefillRow
    },

    computed: {
      is_japan_locale() {
        return this.$store.getters['locale/is_japan_locale'];
      }
    },

    props: {
      list: Array,
      companyId: null
    }
  }
</script>

<style lang="scss" scoped>
  table thead th {
    cursor: default;
    font-size: 14px;

    &.column-date span { 
      white-space: normal;
      display: inline;
    }

    &.column-date,
    &.column-name {
      cursor: pointer;
    }
  }

  .column-id {
    width: 4%;
  }

  .column-date {
    width: 11%;
  }

  .vacancies-table {
    width: 100%;
    margin-top: 34px;

    &.admin-table {
      thead {
        tr:first-child {
          th {
            border-bottom: 1px solid #E5E5E5;
          }
        }
      }
    }
  }
</style>
